import { Card, SwitchInput } from 'corso-admin-ui';
import { DbJsonSchema } from 'corso-types';
import { Controller, useFormContext } from 'react-hook-form';
import { useIsSuperUser } from '~/providers/AuthenticatedUserProvider';
import type { PlatformSettings } from './PlatformPage';

const { featureFlags } = DbJsonSchema.Store;
const flags = featureFlags.keyof().options;

export function FeatureFlagsCard() {
  const isSuperAdmin = useIsSuperUser();
  const { control } = useFormContext<PlatformSettings>();

  // ? only super admins can use this
  if (!isSuperAdmin) return null;
  return (
    <Card>
      <Card.Heading>Feature Flags</Card.Heading>
      <Card.Description>
        Internal toggles for features that are not generally available.
      </Card.Description>

      {flags.map((flag) => (
        <Controller
          key={flag}
          control={control}
          name={`featureFlags.${flag}`}
          render={({ field: { onChange, value }, fieldState }) => (
            <SwitchInput
              id={`feature-flag-${flag}`}
              label={featureFlags.shape[flag].meta()?.title ?? flag}
              details={featureFlags.shape[flag].meta()?.description}
              checked={!!value}
              onChange={onChange}
              error={fieldState.error?.message}
            />
          )}
        />
      ))}
    </Card>
  );
}
